import React from "react";
import { Link, useLocation } from "react-router-dom";
import "../../BinTransfer/BinTransferMain.css";
import { ArrowForwardIos } from "@mui/icons-material";
import { Grid } from "@mui/material";

function DashBoardBreadCrumbs() {
  const location = useLocation();
  const vPathName = location.pathname;
  return (
    <div className="container-fluid p-0">
      {vPathName === "/wmsDashoard" ? (
        <div>
          <span
            className="breadcrumb-not-active "
            //  style={{ fontSize: '1rem', textDecorationLine: 'underline' }}
          >
            Dashboard{" "}
          </span>
        </div>
      ) : vPathName === "/PickingPendingList" ? (
        <div className="d-flex align-items-center">
          <Link
            to="/wmsDashoard"
            state={location.state}
            // style={{ fontSize: '1rem', marginRight: '1rem' }}
            className={"breadcrumb-active mr-2"}
          >
            Dashboard
          </Link>
          <ArrowForwardIos color="info" style={{ marginRight: "1px" }} />
          <div>
            <span
              className="breadcrumb-not-active"
              //  style={{ fontSize: '0.85rem', textDecorationLine: 'underline' }}
            >
              PickingPendingList{" "}
            </span>
          </div>
        </div>
      ) : vPathName === "/PickingDetail" ? (
        <Grid container spacing={0} columns={{ xs: 2, sm: 3, md: 12, lg: 12 }}>
          <Grid item xs={0.8} md={1.5} lg={1}>
            <Link
              to="/wmsDashoard"
              state={location.state}
              // style={{ fontSize: '1rem', marginRight: '1rem' }}
              className={"breadcrumb-active mr-2"}
            >
              Dashoard
            </Link>
          </Grid>
          <Grid item xs={0.2} md={0.2} lg={0.2}>
            <ArrowForwardIos color="info" style={{ marginRight: "10px" }} />
          </Grid>
          <Grid item xs={1} md={2.6} lg={1.6} className="col-5 col-md-3">
            <Link
              to="/PickingPendingList"
              state={{
                ...location.state,
                current: "PickingPendingList",
              }}
              className={"breadcrumb-active mr-2"}
            >
              PickingPendingList
            </Link>
          </Grid>
          <Grid item xs={0.2} md={0.2} lg={0.2} className="col-1 col-md-1">
            <ArrowForwardIos color="info" style={{ marginRight: "10px" }} />
          </Grid>
          <Grid item xs={0.8} md={1.6} lg={1.2}>
            <span
              className="breadcrumb-not-active"
              //  style={{ fontSize: '0.85rem', textDecorationLine: 'underline' }}
            >
              PickingDetail{" "}
            </span>
          </Grid>
        </Grid>
      ) : (
        <></>
      )}
    </div>
  );
}
export default DashBoardBreadCrumbs;
